import React from 'react';
import ReactDOM from 'react-dom';
import { browserHistory, Router, Route, IndexRoute, Link } from 'react-router';

import './modernizr_featurecheck.js';

import './audiocontext-polyfill.js';
import Audiobufferloader from './audiobufferloader';
import './Blob';


window.testForSafari = function(){
  var isSafari = false;
  if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
    isSafari = true;
  }
  return isSafari;
}

window.getIOSVersion = function() {
  if (/iP(hone|od|ad)/.test(navigator.platform)) {
    // supports iOS 2.0 and later: <http://bit.ly/TJjs1V>
    var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
    return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
  }
}


window.testTwitter = function(){
  var isTwitter = false;
   if (/Tw(itt|er)/.test(navigator.userAgent)) {
    isTwitter = true;
   }
   return isTwitter;
}

window.testInstagram = function(){
  var isInstagram = false;
   if (/Insta(gram)/.test(navigator.userAgent)) {
    isInstagram = true;
   }
   return isInstagram;
}



//____________________________________________________________

window.mobileAndTabletcheck = function() {
  var check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};

window.sniffIOSDevice = function() {
  var check = false;
  if( /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream){
    check = true;
  }
  return check;
};


window.checkMediaController=function(){
  var check = false;
  if (!("MediaController" in window)) {
      return check;
  }
  var mc = new MediaController();

  if ("onended" in mc) {
    check = true;
  } else {
    check = true;//partially
    
  }
  return check;
}

window.checkIndexDBSupport = function(){
  if(!window.indexedDB) {
    return false;
  }else{
    return true;
  }
}

class Assets{
  constructor(){
    this.blobSupport = Modernizr.bloburls;
    
    this.webAudio = Modernizr.webaudio;
    this.isMobile = mobileAndTabletcheck();
    this.isIOS = sniffIOSDevice();
    this.isSafari = testForSafari();
    this.mediaControllerSupport = checkMediaController();

    this.iOSVersion = getIOSVersion();
    //initial state ist inline true
    this.canPlayInline = true;

    //Twitter fallback
    this.isTwitter = false;
    this.isTwitter = testTwitter();

    //Instagram fallback

    this.isInstagram = false;
    this.isInstagram = testInstagram();


    this.videoSize = "720p";
    /*
      testcase
    */
    console.log('%cv.2.16', 'font-weight: bolder; color: #4caf50;');

    document.body.className += " isMobile-"+this.isMobile;

    ////___________________________________________ TEST

    //this.isTwitter = true;
    //this.isInstagram = true;
    
    ////___________________________________________ End of TEST

    
    this.test = !this.isMobile ? 0 : 'mobile';
    this.first = false;
    this.second = false;
    this.complete = false;

    if(this.isMobile ){
      if(typeof this.iOSVersion != "undefined"){
        this.canPlayInline = this.iOSVersion[0] > 9;
      }
      this.videoSize = "480p";
    }


    var testCase = {
      Safari : this.isSafari,
      Twitter : this.isTwitter,
      blobSupport : this.blobSupport,
      isMobile : this.isMobile,
      iOS : this.isIOS,
      desktopSafari : (this.isSafari && !this.isMobile),
      isInstagram : this.isInstagram,
      canPlayInline : this.canPlayInline,
      videoSize : this.videoSize,
    }

    console.log('testCase' , testCase);

    // test
    if(this.isMobile){
      window.AudioContext = window.AudioContext||window.webkitAudioContext;
      this.audioContext = new AudioContext();
      this.bufferLoader = new Audiobufferloader(this.audioContext);
      this.audioContextCreationTime = new Date();
    }

    this.loadvideoReqeuest = function(url,name,loadingCallback,callback, indexDBSupport){
      var that = this;
      var xhr = new XMLHttpRequest();
          xhr.open('GET', url, true);
          xhr.responseType = 'blob';
          xhr.onprogress = function(e){
            loadingCallback((e.loaded *  100 / e.total).toFixed(2));
          }
          xhr.onload = function(e) {
            if (this.status == 200) {
              
              var key = name + 'Video';
              that.loaded[key] = e.target.response;
              callback(e.target.response);
    
            }
          };
        xhr.send(); 
    }

    //load video from indexDB or from xhr
    this.loadVideo = function(url,name,loadingCallback,callback){
      this.loadvideoReqeuest(url,name,loadingCallback,callback,false); 
    }

    //change before upload
    this.basePath = './blossomentary/';
    this.root = 'blossomentary'; ///blossom /clients/milkychance/upload/blossom
    this.emailRoot = 'http://dirtysansho.com/clients/milkychance/upload/save';

    this.userImageRoot = "http://blossomentary.milkychance.net/store_data";

    this.size = '480p_';// //super_low_

    this.loaded={
      first : false,
      second : false,
      loadStatus : 0,

      //mobile session
      completeStatus: 0,
      completeVideo : null,
      completeSourcePath:this.basePath + 'video/combined_2.mp4',

      
      mobile_part_first_Status: 0,
      mobile_part_first_Video : null,
      mobile_part_first_SourcePath:this.basePath + 'video/combined_first.mp4',


      mobile_part_last_Status: 0,
      mobile_part_last_Video : null,
      mobile_part_last_SourcePath:this.basePath + 'video/combined_last.mp4',

      //
      introStatus: 0,
      introVideo : null,
      introSourcePath:this.basePath + 'video/'+ this.size + 'i_szene.mp4',
      //helisession
      heliStatus: 0,
      heliVideo : null,
      heliSourcePath: this.basePath + 'video/'+ this.size + 'i_drone.mp4',
      //ifront
      ifrontStatus: 0,
      ifrontVideo : null,
      ifrontSourcePath:this.basePath + 'video/'+ this.size + 'i_front.mp4',
      //videosession
     
      totaleStatus:0,
      totaleVideo :null,
      totaleSourcePath:this.basePath + 'video/'+ this.size + 'totale_voice.mp4',

      guitarStatus:0,
      guitarVideo :null,
      guitarSourcePath:this.basePath + 'video/'+ this.size + 'clemens_guitar.mp4',

      drumsStatus:0,
      drumsVideo :null,
      drumsSourcePath: this.basePath + 'video/'+ this.size + 'philipp_drums.mp4',

      bassStatus:0,
      bassVideo :null,
      bassSourcePath: this.basePath +'video/'+ this.size + 'antonio_bass.mp4',

      //booksession
      bookStatus : 0,
      bookVideo : null,
      bookSourcePath: this.basePath + 'video/'+ this.size + 'book_session.mp4',
      //audio
      audioStatus : 0,
      spur : {
        Bass : {
          name : 'Bass',
          value : .8,
          buffer : null,
          url : this.basePath + 'audio/bass.mp3',
          playing : false,
        },
        Drums : {
          name : 'Drums',
          value : .5,
          buffer : null,
          url : this.basePath + 'audio/drums.mp3',
          playing : false,
        },
        Guitar : {
          name : 'Guitar',
          value : 1,
          buffer : null,
          url : this.basePath + 'audio/guitar.mp3',
          playing : false,
        },
        Vocals : {
          name : 'Vocals',
          value : 1.2 ,
          buffer : null,
          url : this.basePath + 'audio/vocals.mp3',
          playing : false,
        }
      }
    }


    /*
      MAIN TEST FOR DEVICES BEFORE GO FURTHER

        - blobSupport falls back to fallback
        - playInline Video not supported falls back to inline_fallback
      
    */
      if(!this.blobSupport){
        browserHistory.push(this.root + '/fallback');
        console.warn('no blob is supported');
      }

      if(!this.canPlayInline){
        browserHistory.push(this.root + '/inline_fallback');
        console.warn('inline is not supported');
      }
        
      // CAUTION: GO to chapter 1 without assets being loaded
      if(this.isTwitter){
        browserHistory.push(this.root + '/');
        console.warn('is twitter');
      }

      // CAUTION: GO to chapter 1 without assets being loaded
      if(this.isInstagram){
        browserHistory.push('/instagram_fallback');
        console.warn('is Instagram');
      }

      localStorage.setItem('wifi-was-visible', false);
    //this.loadAssets();
  }


  loadAssets(){
    if(this.blobSupport && this.canPlayInline && !this.isTwitter && !this.isInstagram){
      this.init();
    }
  }


  init(){
    
    if(this.isMobile){
      this.loadFirstMobileSession(100);
    }else{
      this.loadStart(200);
    }
    localStorage.setItem('coming-from-intro', false);
    
  }

  getLoadStatus(){
    return this.loaded.loadStatus.toFixed(0);
  }

  completeLoad(max){
    let complete = parseFloat(this.loaded.introStatus) + 
      parseFloat(this.loaded.heliStatus)+ 
      parseFloat(this.loaded.ifrontStatus) +
      parseFloat(this.loaded.totaleStatus) + 
      parseFloat(this.loaded.guitarStatus) + 
      parseFloat(this.loaded.drumsStatus) + 
      parseFloat(this.loaded.bassStatus) +
      parseFloat(this.loaded.bookStatus) +
      parseFloat(this.loaded.completeStatus) +
      parseFloat(this.loaded.mobile_part_first_Status ) +
      parseFloat(this.loaded.mobile_part_last_Status ) +
      parseFloat(this.loaded.completeStatus) +
      parseFloat(this.loaded.audioStatus * 100);//complete
       
      
      /*console.log(
        'complete' , parseFloat(this.loaded.completeStatus), 
        'intro' , parseFloat(this.loaded.introStatus), 
        'heli' , parseFloat(this.loaded.heliStatus),
        'ifront' , parseFloat(this.loaded.ifrontStatus),
        'totale' , parseFloat(this.loaded.totaleStatus), 
        'guitar' , parseFloat(this.loaded.guitarStatus), 
        'drums' , parseFloat(this.loaded.drumsStatus), 
        'bass' , parseFloat(this.loaded.bassStatus),  
        'book' , parseFloat(this.loaded.bookStatus),
        'audio', parseFloat(this.loaded.audioStatus * 100) );*/
      
    
    this.loaded.loadStatus = complete * 100 / max;
    //desktop version
    if(!this.isMobile){  
      if(this.loaded.loadStatus == 100 && this.first){
        //console.log('second ready');
        this.second= true;
        this.complete = true;
      }
      if(this.loaded.loadStatus == 100 && !this.first){
        this.first = true;      
        this.loadSession(800); //800
        //console.log('first ready');
      }
    }else{

      if(this.loaded.loadStatus == 100 && this.first){
        this.second= true;
        this.complete = true;
      }

      if(this.loaded.loadStatus == 100 && !this.first && !this.second){
        this.first= true;
        this.loadSecondMobileSession(600);
      }
      
    }
  }


  loadFirstMobileSession(max){
    //loadAudios
      //completeSource

    this.loadVideo(this.loaded.mobile_part_first_SourcePath , "mobile_part_first_", function(loadStatus){
        this.loaded.mobile_part_first_Status = loadStatus;
        this.completeLoad(max);
      }.bind(this),function(video){
          
        //load audio
        //console.log('mobile first part ready');
        
      }.bind(this));
  }

  loadSecondMobileSession(max){
    this.loadVideo(this.loaded.mobile_part_last_SourcePath , "mobile_part_last_", function(loadStatus){
      this.loaded.mobile_part_last_Status = loadStatus;
      this.completeLoad(max);
    }.bind(this),function(video){
     
      //load audio
      this.loadAudios(max);

    }.bind(this));
  }



  loadAudios(max){
    for(var spur in this.loaded.spur){
      this.loadAudioSingle(spur,this.loaded.spur[spur].url,max);
    }
  }

  loadAudioSingle(name,url,max){

    this.bufferLoader.loadBuffer(name, url,function(buffer) {
      this.loaded.spur[name].buffer = buffer;
      this.loaded.audioStatus++;
      this.completeLoad(max);
    }.bind(this));

  }


  loadStart(max){

     //heliSession
    this.loadVideo(this.loaded.heliSourcePath ,"heli",function(loadStatus){
      this.loaded.heliStatus = loadStatus;
      this.completeLoad(max);
    }.bind(this),function(video){ }.bind(this));

    this.loadVideo(this.loaded.ifrontSourcePath ,"ifront",function(loadStatus){
     this.loaded.ifrontStatus = loadStatus;
      this.completeLoad(max);
    }.bind(this),function(video){ }.bind(this));    
  }


  loadSession(max){
    
     //heliSession
    this.loadVideo(this.loaded.introSourcePath ,"intro",function(loadStatus){
      this.loaded.introStatus = loadStatus;
      this.completeLoad(max);
    }.bind(this),function(video){ }.bind(this));
    //mainSession

    //totale voice drums bass

    this.loadVideo(this.loaded.totaleSourcePath ,"totale",function(loadStatus){
       this.loaded.totaleStatus = loadStatus;
       this.completeLoad(max);
    }.bind(this),function(video){ }.bind(this));
    
    this.loadVideo(this.loaded.guitarSourcePath ,"guitar",function(loadStatus){
       this.loaded.guitarStatus = loadStatus;
       this.completeLoad(max);
    }.bind(this),function(video){ }.bind(this));
    
    this.loadVideo(this.loaded.drumsSourcePath ,"drums",function(loadStatus){
       this.loaded.drumsStatus = loadStatus;
       this.completeLoad(max);
    }.bind(this),function(video){ }.bind(this));
    
    this.loadVideo(this.loaded.bassSourcePath ,"bass",function(loadStatus){
       this.loaded.bassStatus = loadStatus;
       this.completeLoad(max);
    }.bind(this),function(video){ }.bind(this));

    //bookSession
    this.loadVideo(this.loaded.bookSourcePath ,"book",function(loadStatus){
      this.loaded.bookStatus = loadStatus;
       this.completeLoad(max);
    }.bind(this),function(video){ }.bind(this));
    

  }  
}

window._assets = new Assets();



// WEBPACK FOOTER //
// ./src/scripts/assetLoader.js